// extracted by mini-css-extract-plugin
module.exports = {"title":"HeroAttributes_title__8CMYH"};